export const courseSlugToName: Record<string, string> = {
  trigonometry: 'trigonometry',
  geometry: 'geometry',
  sat: 'SAT®',
  calculus: 'calculus',
  ap: 'AP®',
  statistics: 'statistics',
  'pre-algebra': 'pre-algebra',
  'pre-calculus': 'precalc',
  algebra2: 'Algebra 2',
  algebra: 'algebra',
}
